import React from "react";
import { Box, Stack, Typography, CircularProgress } from "@mui/material";

import { formatDate } from "../../../../utils/format";
import {
  TOKENS,
  DetailDrawer,
  Section,
  Monogram,
  StatusPill,
} from "../../../../components/pages/_new/super/design";

const Field = ({ label, value, mono }) => (
  <Box sx={{ mb: 1.5 }}>
    <Typography
      sx={{
        fontSize: 11,
        fontWeight: 600,
        color: TOKENS.fg3,
        textTransform: "uppercase",
        letterSpacing: "0.06em",
        mb: 0.25,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: 13.5,
        color: TOKENS.fg1,
        fontFamily: mono ? "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace" : undefined,
        wordBreak: "break-all",
      }}
    >
      {value || "—"}
    </Typography>
  </Box>
);

function ViewRegionModal({ open, handleClose, region, loading }) {
  const name = region?.name || "—";
  const status = region?.isDeleted ? "Suspended" : "Active";

  return (
    <DetailDrawer
      open={open}
      onClose={handleClose}
      title={loading || !region ? "Region detail" : name}
      subtitle={region?.host_name}
      headerChips={region ? [<StatusPill key="s" status={status} />] : undefined}
    >
      {loading || !region ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={28} />
        </Box>
      ) : (
        <Box>
          <Stack direction="row" alignItems="center" spacing={1.5} sx={{ mb: 2 }}>
            <Monogram name={name} size={48} radius={12} />
            <Box>
              <Typography sx={{ fontSize: 15, fontWeight: 600, color: TOKENS.fg1 }}>{name}</Typography>
              <Typography sx={{ fontSize: 12.5, color: TOKENS.fg2 }}>{region?.host_name}</Typography>
            </Box>
          </Stack>

          <Section label="Endpoint">
            <Field label="Region Name" value={region?.name} />
            <Field label="Host Name" value={region?.host_name} mono />
            <Field label="Edge Private IP" value={region?.edge_ip} mono />
            <Field label="Response Code" value={region?.res_code} />
          </Section>

          <Section label="Lifecycle">
            <Field label="Reachable" value={region?.isActive ? "Online" : "Offline"} />
            <Field label="Created" value={region?.created_at ? formatDate(region.created_at) : ""} />
          </Section>
        </Box>
      )}
    </DetailDrawer>
  );
}

export default ViewRegionModal;
